import styled from 'styled-components';

import BaseButton from 'components/common/buttons/baseButton';

export const SVGIconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.buttons.longModalButton.primary.background};
  width: 330px;
  max-width: 330px;
  height: 60px;
  border-radius: 5px;
  color: ${({ theme }) => theme.buttons.longModalButton.primary.font};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.ui03};
  }
  padding: 8px 10px;
`;

export const LongButtonLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LongButtonPrimaryText = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const RedMarkLabel = styled.span`
  color: red;
  display: inline;
  margin-left: 3px;
`;

export const Icon = styled.div`
  margin: 4px 8px 0 0px;
`;

export const WrapperButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
